import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IEventState }          from 'Redux/Slices/Event/EventSlice';

export const assignEventEmployeesRequest = (state: Draft<IEventState>, { type }: PayloadAction<{ id: string, userIds: string[] }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const assignEventEmployeesSuccess = (state: Draft<IEventState>, { type, payload }: PayloadAction<{ userIds: string[] }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.assignedEmployeeIds = payload.userIds;
};

export const assignEventEmployeesFailure = (state: Draft<IEventState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
